import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const AuthImage = ({ src, alt, className, testid }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let href, live = true;
    api.get(src, { responseType: "blob" }).then((r) => {
      href = URL.createObjectURL(r.data);
      if (live) setUrl(href);
    }).catch(() => {});
    return () => { live = false; if (href) URL.revokeObjectURL(href); };
  }, [src]);
  if (!url) return <div className={`${className} bg-slate-100 animate-pulse`} />;
  return <img src={url} alt={alt} className={className} data-testid={testid} />;
};

export const Sel = ({ label, value, onChange, options, testid, placeholder, disabled }) => (
  <label className="block">
    <span className="eyebrow">{label}</span>
    <select className="field mt-1" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} disabled={disabled}>
      <option value="">{placeholder || "—"}</option>
      {options.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
    </select>
  </label>
);

export const Inp = ({ label, testid, ...props }) => (
  <label className="block">
    <span className="eyebrow">{label}</span>
    <input className="field mt-1" data-testid={testid} {...props} />
  </label>
);

export const PageTitle = ({ children, right }) => (
  <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
    <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">{children}</h1>
    {right}
  </div>
);
